import { NumericFormat } from 'react-number-format';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroupInput,
} from '@/components/ui/input-group';

interface CurrencyInputProps extends Omit<React.ComponentProps<'input'>, 'value' | 'onChange' | 'type' | 'defaultValue'> {
  valueCents: number | undefined;
  onChangeCents: (cents: number | undefined) => void;
}

export function CurrencyInput({ valueCents, onChangeCents, className, ...rest }: CurrencyInputProps) {
  return (
    <InputGroup className={className}>
      <InputGroupAddon align="inline-start">
        <InputGroupText>$</InputGroupText>
      </InputGroupAddon>
      <NumericFormat
        customInput={InputGroupInput}
        thousandSeparator=","
        decimalScale={2}
        fixedDecimalScale
        allowNegative={false}
        value={valueCents !== undefined ? valueCents / 100 : ''}
        onValueChange={({ floatValue }) => {
          onChangeCents(floatValue !== undefined ? Math.round(floatValue * 100) : undefined);
        }}
        {...rest}
      />
    </InputGroup>
  );
}
